import util from '../util';

export const FEED_MAPPING = 'FEED_MAPPING';
export const FEED_MAPPINGS = 'FEED_MAPPINGS';
export const FEED_MAPPING_CREATE = 'FEED_MAPPING_CREATE';
export const FEED_MAPPING_UPDATE = 'FEED_MAPPING_UPDATE';
export const RESET_FEED_MAPPING = 'RESET_FEED_MAPPING';
export const DELETE_FEED_MAPPING = 'DELETE_FEED_MAPPING';

export const FEED_MAPPINGS_REQUEST = util.requestType(FEED_MAPPINGS);
export const FEED_MAPPINGS_SUCCESS = util.successType(FEED_MAPPINGS);
export const FEED_MAPPINGS_FAILURE = util.failureType(FEED_MAPPINGS);

export const FEED_MAPPING_REQUEST = util.requestType(FEED_MAPPING);
export const FEED_MAPPING_SUCCESS = util.successType(FEED_MAPPING);
export const FEED_MAPPING_FAILURE = util.failureType(FEED_MAPPING);

export const CREATE_FEED_MAPPING_REQUEST =
  util.requestType(FEED_MAPPING_CREATE);
export const CREATE_FEED_MAPPING_SUCCESS =
  util.successType(FEED_MAPPING_CREATE);
export const CREATE_FEED_MAPPING_FAILURE =
  util.failureType(FEED_MAPPING_CREATE);

export const UPDATE_FEED_MAPPING_REQUEST =
  util.requestType(FEED_MAPPING_UPDATE);
export const UPDATE_FEED_MAPPING_SUCCESS =
  util.successType(FEED_MAPPING_UPDATE);
export const UPDATE_FEED_MAPPING_FAILURE =
  util.failureType(FEED_MAPPING_UPDATE);

export const DELETE_FEED_MAPPING_REQUEST =
  util.requestType(DELETE_FEED_MAPPING);
export const DELETE_FEED_MAPPING_SUCCESS =
  util.successType(DELETE_FEED_MAPPING);
export const DELETE_FEED_MAPPING_FAILURE =
  util.failureType(DELETE_FEED_MAPPING);
